import type { CreditNoteReason } from "@estelle/domain";

/**
 * The five reasons a credit note can carry, in one place.
 *
 * `fields.ts` builds the Credit Notes list's filter options from this list,
 * and `CreateCreditNote`/`CreditNoteDetail` read the same labels for the
 * reason picker and the printed document — so a sixth reason added here
 * shows up in the filter, the form and the document without three separate
 * edits drifting out of sync with each other.
 */
export const CREDIT_NOTE_REASONS: { value: CreditNoteReason; label: string }[] =
  [
    { value: "order_cancelled", label: "Order cancelled" },
    { value: "full_refund", label: "Full refund" },
    { value: "partial_refund", label: "Partial refund" },
    { value: "return", label: "Return" },
    { value: "correction", label: "Correction" },
  ];

/** Falls back to the raw value only if the union outgrows this list. */
export function reasonLabel(reason: CreditNoteReason): string {
  return (
    CREDIT_NOTE_REASONS.find((entry) => entry.value === reason)?.label ?? reason
  );
}
